var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6097 13.8367V5.17M10.3896 12.0899V3.16994M1.42969 11.3167V4.83001C1.42969 3.56334 2.32969 3.04334 3.42302 3.67001L4.98969 4.56334C5.32969 4.75667 5.89635 4.77667 6.24969 4.59667L9.7497 2.84334C10.103 2.67001 10.6697 2.68334 11.0097 2.87667L13.8964 4.53001C14.263 4.74334 14.5697 5.26334 14.5697 5.69001V12.1767C14.5697 13.4434 13.6697 13.9634 12.5764 13.3367L11.0097 12.4434C10.6697 12.25 10.103 12.23 9.7497 12.41L6.24969 14.1567C5.89635 14.33 5.32969 14.3167 4.98969 14.1234L2.10302 12.47C1.72969 12.2567 1.42969 11.7367 1.42969 11.3167Z",
    stroke: "url(#paint0_linear_2759_3636)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2759_3636",
    x1: 15.8339,
    y1: 4.04609,
    x2: 2.89558,
    y2: 1.36769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7030A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#D96380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF934E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigate);
export default __webpack_public_path__ + "static/media/navigate.85bca57efc63e1ed8e0989ff4d23687e.svg";
export { ForwardRef as ReactComponent };